import { Infra3DSDKError } from "./Infra3DSDKError";
/**
 * @class AbortInfra3DSDKError
 *
 * @classdesc Error thrown when a move to request has been
 * aborted before completing because of a subsequent request.
 */
export class AbortInfra3DSDKError extends Infra3DSDKError {
    constructor(message) {
        super(message != null ? message : "The request was aborted.");
        Object.setPrototypeOf(this, AbortInfra3DSDKError.prototype);
        this.name = "AbortInfra3DSDKError";
    }
}
//# sourceMappingURL=AbortInfra3DSDKError.js.map